// extracted by mini-css-extract-plugin
module.exports = {"faq":"Faq_faq__Zn7EP","question":"Faq_question__LpKbN","answer":"Faq_answer__JeyK6"};